import moment from "moment";
import { LoadState } from "../../constants/enums";

import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { IServiceItem } from "../service";

export interface ILeadsState {
  list: {
    list: ILead[];
    totalRecords: number;
    loading: LoadState;
    error: string | null;
  };
  lead: {
    data: ILead;
    loading: LoadState;
    error: string | null;
  };
  roughEstimate: {
    data: IRoughEstimate[];
    loading: LoadState;
    error: string | null;
  };

  generalHistory: {
    list: IGeneralHistory[];
    loading: LoadState;
  };
  recordCounts: {
    list: ILeadStatusCount[];
    loading: LoadState;
  };
  whatsappStatusUnrepliedCounts: {
    list: IWhatsAppStatusUnrepliedCount[];
    loading: LoadState;
  };
  driveStatusList: {
    list: any[];
    loading: LoadState;
  };
  driveStatusCategoryList: {
    list: any[];
    loading: LoadState;
  };
  bulkUpload: IBulkUploadLeadsState;
}

export interface IBulkUploadMappingKey {
  check: number;
  label: string;
  column: string;
}

export interface IBulkUploadLeadsPayload {
  source_link: string[];
  mapping_keys: IBulkUploadMappingKey[];
  hardcoded_values: {
    priority?: string;
    status?: string;
    actual_status?: string;
    drive_status_uuid?: string;
    [key: string]: any;
  };
  company_outlet_uuid: string;
}

export interface IBulkUploadLeadsState {
  loading: LoadState;
  error: string | null;
  success: boolean;
}

export interface IWhatsAppStatusUnrepliedCount {
  [key: string]: number;
}
export interface ILead {
  leads_uuid: string | null;
  reference_from_action_item_uuid?: string | null;
  country_code: string;
  lead_code: string;
  date_of_visit: string;
  function_date: string | null;
  function_month: string | null;
  // function_year: string | null;
  name_of_guest: string;
  country_iso_code: string,
  contact_number_one: string;
  email: string | null;
  event_type: string;
  event_uuid: string;
  number_of_guests: number | null;
  handled_by_employee: string;
  // alt_function_month: string;

  event_time: string;
  event_time_uuid: string;
  preferred_venue: string | null;
  preferred_venue_uuid: string | null;
  number_of_rooms: number | null;
  remarks: string;
  event_name: string;
  event_timing_uuid: string;
  whatsapp_status: string;
  is_replied: number | null;
  company_outlet_uuid: string;
  company_outlet_name: string;
  booking_date: string | null;
  is_payment_transaction_exist: number;
  grand_total: string | null;
  is_archived: number;
  payment_mode: "BILL_TO_COMPANY" | "DIRECT" | null;
  cancellation_dead_reason: string | null;
  other_event_name: string | null;
  duplicate_reference_uuid?: string | null;
  duplicate_reference_contact_number?: string | null;
  estimated_rough_revenue: string | null;
  guest_budget: string | null;
  // venue_name: string;

  handled_by_employee_uuid: string;
  master_status_uuid: string | null;
  status: "ONGOING" | "CANCELLED" | "BOOKED" | "POSTPONED" | "DEAD";
  actual_status: string | null;

  drive_status_uuid: string | null;
  followup_date: string | null;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
  to_number?: string;
  multiple_events: number;
  multiple_events_uuid: string | null;
  multiple_events_list: IMultipleEvent[];
  description: string | null;
  lead_source_uuid: string | null;
  source: string | null;

  additional_contact_number: IAdditionalContactNumber[];

  group_status: IGroupEventStatus[];
  priority?: string | null;

  extras?: IEventExtras | null;
  relation_with_customer?: string | null;
}

export interface IGroupEventStatus {
  eventName: string;
  status: string;
}
export interface IAdditionalContactNumber {
  contact_number: string;
  country_code: string;
  country_iso_code: string;
  name: string;
  relation_with_customer?: string | null;
}

// Multiple events data structure
export interface IMultipleEvent {
  leads_uuid: string | null;
  event_type: string;
  event_uuid: string;
  event_time: string;
  event_time_uuid: string;
  preferred_venue: string | null;
  preferred_venue_uuid: string;
  // Event-specific fields (independent per row)
  booking_date: string | null;
  function_month?: string | null;
  function_date?: string | null;
  followup_date?: string | null;
  status: string;
  actual_status: string;
  drive_status_uuid: string;
  service?: IServiceItem[] | null;
  number_of_rooms: number | null;
  number_of_guests: number | null;
  estimated_rough_revenue?: string | null;
  guest_budget?: string | null;
  relation_with_customer?: string | null;
  customer_relative_name?: string | null;

  // Conditional fields
  cancellation_dead_reason?: string | null;
  payment_mode?: "BILL_TO_COMPANY" | "DIRECT" | null;
  other_event_name?: string | null;
  duplicate_reference_uuid?: string | null;
  duplicate_reference_contact_number?: string | null;
  is_archived: number;

  show_month_picker?: boolean;

  /** Custom Title — free-form key/value fields (e.g. couple names) shown on the outlet quotation cover page */
  extras?: IEventExtras | null;
}

/** Custom Title key/value map, e.g. { "Bride_and_groom": "ANKIT WEDS ANKITA" } */
export type IEventExtras = Record<string, string>;

// Dynamic form fields data structure
// Key: field_uuid (form_labels_uuid)
// Value: Object with field_name and value
export interface IExtras {
  [field_uuid: string]: {
    field_name: string;
    value: string | number | boolean | string[] | null | undefined;
  };
}


export interface ItemCharge {
  name: string;
  description: string;
  count: number;
  amount: string;
  gst_percentage: number;
  gst_amount: string;
  sub_total: string;
  total: number;
  /** Per-line discount: interpreted as % when discount_mode is percentage, else flat amount */
  discount_mode?: "percentage" | "amount";
  discount?: string | number;
  /** Attachments carried over from the linked service item (if this line came from ServicesAutoSearch) */
  attachments?: IFileUpload[] | null;
  /** Tax type carried from the linked master menu package (defaults to GST) */
  tax_type?: "GST" | "VAT" | "HST" | null;
  /** VAT percentage — only applicable when tax_type is "VAT" (string while editing to allow decimals) */
  vat_percentage?: number | string;
  /** Computed VAT amount */
  vat_amount?: string;
}

export interface IStayDetail {
  room_name: string;
  check_in: string | null;
  check_out: string | null;
  rooms: number;
  nights: number;
  /** Rack rate per room per night (sent to the API as `amount`) */
  price: number | string;
  /** Rack rate as returned by the multi-event quotation API */
  amount?: number | string;
  sub_total: number;
  discount_mode: "percentage" | "amount";
  discount: number | string;
  gst_percentage: number;
  gst_amount: number;
  vat_amount?: number;
  total: number;
}

/** One event (lead) inside a multi-event quotation, holding its own item charges. */
export interface IRoughEstimateEvent {
  leads_uuid: string | null;
  booking_date: string | null;
  function_date: string | null;
  venue_name: string | null;
  guest_count: number;
  items_charges: ItemCharge[];
  /** Display-only fields the API may return alongside the event */
  event_type?: string | null;
  event_name?: string | null;
  lead_status?: string | null;
  actual_status?: string | null;
  lead_code?: string | null;
  /** The grouped quotation API returns the quotation uuid/status on each event */
  rough_estimate_uuid?: string | null;
  quotation_status?: IRoughEstimate["status"] | null;
  is_default_event?: number;
  is_included_in_total?: number;
}

/** Payload for `/leads/upsert-rough-estimate` — one quotation per `multiple_events_uuid`. */
export interface IRoughEstimateUpsertPayload {
  rough_estimate_uuid: string | null;
  multiple_events_uuid: string | null;
  company_outlet_uuid: string | null;
  contact_number: string | null;
  gst_pan_number: string | null;
  status: IRoughEstimate["status"];
  attachments: IFileUpload[];
  remarks: string;
  stay_details: {
    room_name: string;
    check_in: string | null;
    check_out: string | null;
    rooms: number;
    nights: number;
    amount: number;
    discount: number;
    discount_mode: "percentage" | "amount";
    gst_amount: number;
    vat_amount: number;
    total: number;
  }[];
  discount_mode: "percentage" | "amount";
  discount: string;
  sub_total: number;
  total_gst: number;
  total_vat: number;
  tax_amount: string;
  tax_percentage: number | null;
  extras_amount: string;
  advance_amount: string | null;
  grand_total: string;
  events: {
    leads_uuid: string | null;
    booking_date: string | null;
    function_date: string | null;
    venue_name: string | null;
    guest_count: number;
    items_charges: (Omit<ItemCharge, "discount"> & { discount: number })[];
  }[];
}

export interface IRoughEstimate {
  rough_estimate_unique_id: number | null;
  rough_estimate_uuid: string | null;
  leads_uuid: string | null;
  booking_date: string | null;
  function_date: string | null;
  contact_number: string | null;
  venue_name: string | null;
  guest_count: number;
  gst_pan_number: string | null;
  items_charges: ItemCharge[];
  stay_details: IStayDetail[];
  sub_total: string;
  tax_amount: string;
  tax_percentage: number | null;
  extras_amount: string;
  discount: string;
  discount_mode: "percentage" | "amount";
  advance_amount: string | null;
  grand_total: string;
  attachments: IFileUpload[] | null;
  status: "ACTIVE" | "ONGOING" | "CANCELLED" | "BOOKED" | "POSTPONED" | "DRAFT" | "QUOTATION_SENT";
  company_outlet_uuid: string | null;
  company_outlet_name: string | null;
  company_outlet_branch_uuid: string | null;
  created_by_uuid: string | null;
  created_by_name: string | null;
  modified_by_uuid: string | null;
  modified_by_name: string | null;
  create_ts: string | null;
  insert_ts: string | null;
  payment_status: "UNPAID" | "PARTIALLY_PAID" | "PAID";
  is_payment_transaction_exist: number;
  total_amount_paid: number;
  remaining_balance: number;
  total_gst: number;
  total_vat?: number;
  multiple_events_uuid?: string | null;
  remarks?: string;
  /** Per-event item charges of a multi-event quotation */
  events?: IRoughEstimateEvent[];
}

export interface ILeadStatusCount {
  [key: string]: number;
}

export interface IGeneralHistory {
  insert_ts: string;
  [key: string]: any;
}

export interface ILeadSource {
  lead_source_uuid: string | null;
  source_name: string | null;
  source_name_link: string | null;
  company_outlet_uuid: string | null;
  status: "ACTIVE" | "INACTIVE";
}

export const initialLeadSource: ILeadSource = {
  lead_source_uuid: null,
  source_name: null,
  source_name_link: null,
  company_outlet_uuid: null,
  status: "ACTIVE",
};

export const initialMultipleEvent: IMultipleEvent = {
  leads_uuid: null,
  event_type: "",
  event_uuid: "",
  event_time: "",
  event_time_uuid: "",
  preferred_venue: "",
  preferred_venue_uuid: "",
  booking_date: null,
  status: "",
  actual_status: "ONGOING",
  drive_status_uuid: "",
  number_of_rooms: null,
  number_of_guests: null,
  estimated_rough_revenue: null,
  guest_budget: null,
  duplicate_reference_uuid: null,
  duplicate_reference_contact_number: null,
  is_archived: 0,
};

export const initialLead: ILead = {
  leads_uuid: null,

  lead_code: "",
  date_of_visit: moment().format(),
  function_date: null,
  email: null,
  function_month: null,
  name_of_guest: "",
  country_code: "",
  country_iso_code: "",
  contact_number_one: "",
  event_type: "",
  event_uuid: "",
  // function_year: null,
  booking_date: null,
  number_of_guests: null,
  handled_by_employee: "",
  // alt_function_month: "",
  event_time: "",
  event_time_uuid: "",
  preferred_venue: "",
  preferred_venue_uuid: "",
  number_of_rooms: null,
  remarks: "",
  status: "ONGOING",
  followup_date: "",
  event_name: "",
  event_timing_uuid: "",
  whatsapp_status: "",
  company_outlet_uuid: "",
  company_outlet_name: "",
  handled_by_employee_uuid: "",
  estimated_rough_revenue: null,
  guest_budget: null,

  is_replied: null,
  is_payment_transaction_exist: 0,
  grand_total: null,
  is_archived: 0,
  payment_mode: null,
  cancellation_dead_reason: null,
  master_status_uuid: null,
  other_event_name: null,
  duplicate_reference_uuid: null,
  duplicate_reference_contact_number: null,
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  drive_status_uuid: "",
  actual_status: "ONGOING",

  extras: null,
  multiple_events: 0,
  multiple_events_uuid: null,
  multiple_events_list: [],
  description: null,
  lead_source_uuid: null,
  source: null,

  additional_contact_number: [],
  group_status: [],
  priority: "HOT",
  relation_with_customer: null,
};

export const initialRoughEstimate: IRoughEstimate = {
  rough_estimate_unique_id: null,
  rough_estimate_uuid: null,
  leads_uuid: null,
  booking_date: null,
  function_date: null,
  contact_number: null,
  venue_name: null,
  guest_count: 0,
  gst_pan_number: null,
  items_charges: [],
  stay_details: [],
  sub_total: "0.00",
  tax_amount: "0.00",
  tax_percentage: null,
  extras_amount: "0.00",
  discount: "0.00",
  discount_mode: "percentage",
  advance_amount: null,
  grand_total: "0.00",
  attachments: null,
  status: "DRAFT",
  company_outlet_uuid: null,
  company_outlet_name: null,
  company_outlet_branch_uuid: null,
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
  payment_status: "UNPAID",
  is_payment_transaction_exist: 0,
  total_amount_paid: 0,
  remaining_balance: 0,
  total_gst: 0,
  total_vat: 0,
  multiple_events_uuid: null,
  remarks: "",
  events: [],
};

export const initialLeadState: ILeadsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.Loaded,
    error: null,
  },
  lead: {
    data: initialLead,
    loading: LoadState.NotLoaded,
    error: null,
  },
  roughEstimate: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },

  generalHistory: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  recordCounts: {
    list: [],

    loading: LoadState.NotLoaded,
  },
  whatsappStatusUnrepliedCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  driveStatusList: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  driveStatusCategoryList: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  bulkUpload: {
    loading: LoadState.NotLoaded,
    error: null,
    success: false,
  },
};
